import * as React from 'react';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Grid,
} from '@material-ui/core';
import EditCompany from './EditCompany';
import type ICompanyContactDetails from './CompanyInterfaces';
import { emptyCompanyContactDetails } from '../adminHelpers';

const Company: React.FC<unknown> = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { companyIdParam } = useParams();

  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const [editingHidden] = React.useState<boolean>(false);
  const [companyFormValues, setCompanyFormValues] = React.useState<ICompanyContactDetails>(emptyCompanyContactDetails);

  const fetcher = (url: string) => axios.get<ICompanyContactDetails>(url)
    .then((result) => {
      setCompanyFormValues(result.data);
      return result.data;
    });

  useSWR<ICompanyContactDetails, AxiosError>(
    companyIdParam
      ? `/company/getCompany?companyId=${companyIdParam}`
      : null,
    (url) => fetcher(url),
  );

  const handleBackToAllCompaniesClicked = () => {
    navigate('/companies');
  };

  const handleSaveBtnClicked = () => {
    if (companyFormValues) {
      console.log(companyFormValues);
      setIsFetching(true);

      axios.post('/company/upsertCompany', {
        CompanyId: companyFormValues.companyId,
        Name: companyFormValues.name,
        Address1: companyFormValues.address1,
        Email: companyFormValues.email ?? '',
        City: companyFormValues.city,
        State: companyFormValues.state,
        ZipCode: companyFormValues.zipCode,
        Tags: companyFormValues.tags,
      })
        .then(() => {
          if (editingHidden) {
            enqueueSnackbar(`Added company: ${companyFormValues.name}.`);
          } else {
            enqueueSnackbar(`Updated company: ${companyFormValues.name}.`);
          }
          navigate('/companies');
        })
        .catch((error: AxiosError) => {
          if (error?.message) {
            enqueueSnackbar('Unable to save company data', { persist: false, variant: 'error' });
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  };

  return (
    <Grid lg={8} xs={12}>
      <EditCompany
        backToAllCompanies={handleBackToAllCompaniesClicked}
        companyFormValues={companyFormValues}
        editingHidden={editingHidden}
        handleSaveBtnClicked={handleSaveBtnClicked}
        isFetching={isFetching}
        setCompanyFormValues={setCompanyFormValues}
      />
    </Grid>
  );
};

export default Company;
